import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SettingsIcon from "@mui/icons-material/Settings";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Drawer from "@mui/material/Drawer";
import { auth } from "./firebaseConfig";
import { useNavigate } from "react-router-dom";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import UserPhoto from "./components/UserPhoto";
import Contracts from "./pages/Contracts";
import Settings from "./pages/Settings";

const Dashboard = () => {
  const navigate = useNavigate();
  const [activePage, setActivePage] = useState("Dashboard");
  const [loading, setLoading] = useState(true);
  const [userName, setUserName] = useState("");
  const [userPhoto, setUserPhoto] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  useEffect(() => {
    const fetchUser = async () => {
      const user = auth.currentUser;
      const userId = user.uid;

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/users/${userId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${await user.getIdToken(true)}`,
          },
        }
      );

      if (response.ok) {
        const responseData = await response.json();
        setUserName(responseData.response.name);
        setUserPhoto(responseData.response.photoUrl);
      } else {
        console.error('Failed to fetch user data');
      }
      setLoading(false);
    };

    fetchUser();
  }, [navigate]);

  const handleAvatarClick = (event) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSettings = () => {
    setActivePage("Configurações");
    handleClose();
  };

  const handleLogout = () => {
    auth.signOut();
    navigate("/");
  };

  const renderContent = () => {
    switch (activePage) {
      case "Dashboard":
        return <Contracts />;
      case "Meus contratos":
        return <Contracts />;
      case "Configurações":
        return <Settings />;
      default:
        return <Typography>Página não encontrada.</Typography>;
    }
  };

  const drawerWidth = 240;

  const AppBar = styled(MuiAppBar)(({ theme }) => ({
    backgroundColor: "white",
    boxShadow: "none",
    zIndex: theme.zIndex.drawer + 1,
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
  }));

  const Main = styled("main")(({ theme }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    paddingTop: `calc(${theme.mixins.toolbar.minHeight}px + ${theme.spacing(1)})`,
    overflow: 'hidden', // Prevent scrolling
  }));

  if (loading) {
    return <Typography>Carregando...</Typography>;
  }

  return (
    <Box sx={{ display: "flex", height: '100vh', overflow: 'hidden' }}>
      <CssBaseline />

      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
        variant="permanent"
        anchor="left"
      >
        <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', color: 'text.primary', m: 2 }}>
          Agreedly
        </Typography>

        <List>
          <ListItem disablePadding onClick={() => setActivePage("Meus contratos")}>
            <ListItemButton>
              <ListItemIcon><DashboardIcon /></ListItemIcon>
              <ListItemText primary="Meus contratos" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding onClick={() => setActivePage("Configurações")}>
            <ListItemButton>
              <ListItemIcon><SettingsIcon /></ListItemIcon>
              <ListItemText primary="Configurações" />
            </ListItemButton>
          </ListItem>
        </List>
        <Divider />
      </Drawer>

      <AppBar position="fixed">
        <Toolbar>
          <Box sx={{ flexGrow: 1 }} />
          <UserPhoto userName={userName} userPhoto={userPhoto} onClick={handleAvatarClick} />
          <Menu
            anchorReference="anchorPosition"
            anchorPosition={{ top: 70, left: window.innerWidth - 170 }}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <MenuItem onClick={handleSettings}>Configurações</MenuItem>
            <MenuItem onClick={handleLogout}>Sair</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      <Main>
        {renderContent()}
      </Main>
    </Box>
  );
};

export default Dashboard;